
import axios, { AxiosRequestConfig } from "axios";
import VueScrollTo from "vue-scrollto";

/* Vuelidate */
import { Watch, Component, Vue, Prop } from "vue-property-decorator";
import Vuelidate from "vuelidate";
import vuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import customFormGroup from "@/components/Base/Form/BaseFormGroup.vue";
import { TranslateResult } from "vue-i18n";

Vue.component("FormWrapper", templates.FormWrapper);
Vue.use(Vuelidate);
Vue.use(vuelidateErrorExtractor, {
  // template: customFormGroup
});
Vue.component("FormGroup", customFormGroup);

@Component({})
export default class BaseForm extends Vue {
  @Prop({ default: false })
  readonly disabled!: boolean;

  public isSent: boolean = false;
  public isSending: boolean = false;
  public isError: boolean = false;
  public errorMessage: string | TranslateResult = "";
  public responseData: string = "";
  public serverData: object = {};
  public serverSideErrors: object = {};
  public formUrl: string = "";
  public form: object = {};
  public formName: any = "form";

  provide() {
    // tego się pozbyć
    const sserrors = {};
    Object.defineProperty(sserrors, "errors", {
      enumerable: true,
      get: () => this.serverSideErrors
    });
    return { sserrors };
  }

  mounted() {
    this.reset();
  }

  beforeDestroy() {
    this.reset();
  }

  scrollToError() {
    this.$nextTick(function() {
      const els = document.querySelector(".has-error");
      if (els) {
        VueScrollTo.scrollTo(els, 300, {
          offset: -40
        });
      }
    });
  }

  reset() {
    this.$v && this.$v[this.formName].$reset();
    this.errorMessage = "";
    this.isError = false;
    this.isSending = false;
    this.isSent = false;
    this.$store.commit("Form/resetErrors");
    this.$store.commit("Form/setDisabled", this.disabled);
  }

  isSubmitDisabled() {
    return this.disabled;
  }

  draft() {
    (this as any)[this.formName].draft = true;
    this.submit(true);
  }

  submit(skipValidation?: boolean) {
    const validator = this.$v[this.formName];

    if (this.isSubmitDisabled()) {
      return false;
    }

    this.isSending = true;

    if (!skipValidation) {
      validator.$touch();
    }

    if (!validator.$error || skipValidation) {
      this.reset();

      if (this.$recaptcha) {
        this.$recaptcha("send_form").then((token: string) => {
          (this as any)[this.formName].recaptcha = token;
          this.realSubmit().then(this.afterSubmit);
        });
      } else {
        this.realSubmit().then(this.afterSubmit);
      }
    } else {
      this.scrollToError();
      this.isSending = false;
    }
  }

  getFormData() {
    return (this as any)[this.formName];
  }

  getAxiosOptions(): AxiosRequestConfig {
    return {
      data: null,
      method: (this as any)[this.formName].id ? "put" : "post",
      responseType: "json",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json"
      },
      url: this.formUrl
    };
  }

  async realSubmit() {
    const data = await this.getFormData();
    const axiosOptions = this.getAxiosOptions();

    this.$set(this, "serverSideErrors", {});
    this.isSending = true;
    this.isError = false;
    this.isSent = false;

    return axios({
      ...axiosOptions,
      data
    })
      .then((res: any) => {
        this.isSending = false;
        // this.$v[this.formName].$touch();
        if (res.data && res.data.success) {
          this.isSent = true;
          this.$emit("form:sent", res.data.object);
        } else if (res.data && !res.data.success && res.data.errors) {
          this.isError = true;
          this.errorMessage = res.data.message;
          this.$emit("form:error", res.data.message);
          this.$set(this, "serverSideErrors", res.data.errors);

          this.scrollToError();
        } else {
          const message = res.data.message || this.$t("form_error_connection");
          this.isError = true;
          this.errorMessage = message;
          this.$emit("form:error", message);
        }

        this.serverData = res.data.object || {};
        this.responseData = res;
        return res;
      })
      .catch((res: any) => {
        this.isError = true;
        this.isSending = false;
        this.errorMessage = this.$t("form_error_connection");
        this.responseData = res;
        this.$emit("form:error", this.$t("form_error_connection"));
      });
  }

  afterSubmit(res: any) {
    return res;
  }
}
